import React, { useEffect, useState } from 'react';
import './ResetUserPassword.scss';
import { useParams } from 'react-router-dom';
import Logo from './Logo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { resetUserPassword } from '../../../crud/users_api/users';
import SuccessChange from './components/SuccessChange';

const ResetUserPassword: React.FC = () => {
  const { user_id, code } = useParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const hasUpperCase = /[A-Z]/.test(newPassword);
  const hasNumber = /[0-9]/.test(newPassword);
  const hasMinLength = newPassword.length >= 8;
  const passwordsMatch = newPassword === confirmPassword && newPassword.length > 0;
  const [isNewPasswordShown, setIsNewPasswordShown] = useState(false);
  const [isConfirmPasswordShown, setIsConfirmPasswordShown] = useState(false);
  const [error, setError] = useState('');
  const [showSuccessChange, setShowSuccessChange] = useState(false); // Estado para mostrar SuccessChange

  const toggleNewPasswordVisibility = () => setIsNewPasswordShown(!isNewPasswordShown);
  const toggleConfirmPasswordVisibility = () => setIsConfirmPasswordShown(!isConfirmPasswordShown);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (user_id && code && newPassword) {
      resetUserPassword(Number(user_id), code, newPassword)
        .then(() => {
          setShowSuccessChange(true); // Muestra SuccessChange en caso de éxito
        })
        .catch((err: any) => {
          console.log(err);
          setError('Ocurrió un error al cambiar la contraseña. Por favor, inténtalo más tarde.');
        });
    }
  };

  return (
    <div className="reset-password-container">
      {showSuccessChange ? (
        <SuccessChange success={true} /> // Muestra SuccessChange en caso de éxito
      ) : (
        <div className="reset-password-card">
          <div className="reset-password-logo">
            <Logo className="logo-animate" />
          </div>
          <h3 className="reset-password-title">Crea una contraseña segura</h3>
          <p className="reset-password-description">
            Tu contraseña debe cumplir los siguientes requisitos:
          </p>
          <ul className="reset-password-requirements">
            <li className={hasUpperCase ? 'requirement met' : 'requirement'}>
              <FontAwesomeIcon icon={hasUpperCase ? faCheck : faTimes} className="icon" />
              Contiene una mayúscula
            </li>
            <li className={hasMinLength ? 'requirement met' : 'requirement'}>
              <FontAwesomeIcon icon={hasMinLength ? faCheck : faTimes} className="icon" />
              Tiene al menos ocho caracteres
            </li>
            <li className={hasNumber ? 'requirement met' : 'requirement'}>
              <FontAwesomeIcon icon={hasNumber ? faCheck : faTimes} className="icon" />
              Incluye un número
            </li>
            <li className={passwordsMatch ? 'requirement met' : 'requirement'}>
              <FontAwesomeIcon icon={passwordsMatch ? faCheck : faTimes} className="icon" />
              Las contraseñas coinciden
            </li>
          </ul>
          <form onSubmit={handleSubmit}>
            <div className="reset-password-input-group">
              <input
                type={isNewPasswordShown ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Nueva contraseña"
                required
              />
              <button
                type="button"
                onClick={toggleNewPasswordVisibility}
                className="password-toggle"
              >
                <FontAwesomeIcon icon={isNewPasswordShown ? faEyeSlash : faEye} />
              </button>
            </div>
            <div className="reset-password-input-group">
              <input
                type={isConfirmPasswordShown ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Repite la nueva contraseña"
                required
              />
              <button
                type="button"
                onClick={toggleConfirmPasswordVisibility}
                className="password-toggle"
              >
                <FontAwesomeIcon icon={isConfirmPasswordShown ? faEyeSlash : faEye} />
              </button>
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className="reset-password-button">
              Cambiar contraseña
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default ResetUserPassword;
